import { colorPalette } from 'ui-blocks/ColorPalette';

export const narratorSectionStyles = {
	mainContainer: {
		display: 'flex',
		flexDirection: { xs: 'column-reverse ', mobileUi: 'row' },
		gap: { xs: '24px', xxl: '152px' },
		width: '100%',
	},
	flagContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: '16px',
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	videoDescriptionContainer: {
		backgroundColor: 'colors.dark45',
		padding: '24px 16px',
		borderBottomLeftRadius: {
			xs: '16px',
			smTab: '32px',
		},
		borderBottomRightRadius: {
			xs: '16px',
			smTab: '32px',
		},
	},
	baseVideo: {
		border: `1px solid ${colorPalette.dark3}`,
		objectFit: 'cover',
		width: '100%',
		height: '100%',
	},
	baseVideoContainerStyle: {
		aspectRatio: '1.5',
		width: '100%',
		height: '100%',
	},
};
